<template>
  <div id="index">
    <a-layout id="index-layout">
      <a-layout-sider
        breakpoint="lg"
        collapsedWidth="0"
        @collapse="onCollapse"
        @breakpoint="onBreakpoint"
        style="min-height:100vh"
      >
        <LeftMenu />
      </a-layout-sider>
      <a-layout :style="{ background: '#F8F8FA' }">
        <a-layout-header class="header">
          <TopBar v-if="isRouterAlive" :EnvironmentType="EnvironmentType" />
        </a-layout-header>
        <a-layout-content :style="{ margin: '0 16px 0' }">
          <div :style="{ minHeight: '360px' }">
            <keep-alive :max="1">
              <router-view v-if="$route.meta.keepAlive">
                <!-- 这里是会被缓存的视图组件，比如 Home！---max允许被缓存的个数 -->
              </router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive">
              <!-- 这里是不会被缓存的视图组件，比如 Profile！ -->
            </router-view>
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import LeftMenu from '@/components/LeftMenu'
import TopBar from '@/components/TopBar'
export default {
  name: 'index',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      EnvironmentType: '',
      isRouterAlive: true
    }
  },
  components: {
    LeftMenu,
    TopBar
  },
  mounted () {
    // 发布环境
    // this.EnvironmentType = '测试环境'
    // this.EnvironmentType = '开发环境'
    // this.EnvironmentType = '预发布环境'
    // this.EnvironmentType = '' // 正式环境
    this.EnvironmentType = process.env.VUE_APP_EnvironmentType
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    onCollapse (collapsed, type) {
    },
    onBreakpoint (broken) {
    }
  }
}
</script>

<style lang="less">
.ant-layout-sider {
  max-width: 184px !important;
  min-width: 184px !important;
  width: 184px !important;
}
</style>
<style lang="less" scoped>
// @topbar-default-color: #f59a2380; // 测试环境区分topbar颜色
// @topbar-default-color: #d9001b80; // 预发布区分topbar颜色
// @topbar-default-color: #8f9e7c80; // 开发环境区分topbar颜色
// @topbar-default-color: #fff; // 正式区分topbar颜色

#index {
  height: 100%;
  #index-layout {
    height: 100%;
    .header {
      // background: @topbar-default-color;
      background: var(--topBar-default-color);
      padding: 0 40px;
    }
  }
}
</style>
